import * as THREE from 'three';
const feedbackByHost = new WeakMap();
function removeRotationCenterFeedback(host, expectedFeedback) {
    const feedback = feedbackByHost.get(host);
    if (!feedback || (expectedFeedback && feedback !== expectedFeedback)) {
        return;
    }
    if (feedback.timeout !== null) {
        clearTimeout(feedback.timeout);
    }
    host.scene.remove(feedback.sphere);
    feedback.geometry.dispose();
    feedback.material.dispose();
    feedbackByHost.delete(host);
}
export function setRotationCenterToOrigin(host) {
    // Temporarily remove change listener to prevent continuous rendering
    const changeHandler = () => host.requestRender();
    if (host.controls) {
        host.controls.removeEventListener('change', changeHandler);
    }
    // Set rotation center (target) to origin (0, 0, 0)
    host.controls.target.set(0, 0, 0);
    host.controls.update();
    // Update axes position to the new rotation center
    const axesGroup = host.axesGroup;
    if (axesGroup) {
        axesGroup.position.copy(host.controls.target);
    }
    // Re-add change listener
    if (host.controls) {
        host.controls.addEventListener('change', changeHandler);
    }
    // Show axes temporarily to indicate new rotation center
    const showAxesTemporarily = host.showAxesTemporarily;
    if (showAxesTemporarily) {
        showAxesTemporarily();
    }
    // Single render request for the rotation center change
    host.requestRender();
    updateRotationOriginButtonState(host);
}
export function setRotationCenter(host, point) {
    const axesGroup = host.axesGroup;
    host.rotationCenterManager.setRotationCenter(point, host.camera, host.controls, axesGroup, {
        updateRotationOriginButtonState: () => updateRotationOriginButtonState(host),
        showAxesTemporarily: host.showAxesTemporarily,
        requestRender: () => host.requestRender(),
    });
    // Visual feedback
    showRotationCenterFeedback(host, host.controls.target);
}
export function showRotationCenterFeedback(host, point) {
    // Safari can emit a compatibility double-click after our touch double-tap,
    // and consecutive asynchronous picks can complete close together. Keep the
    // feedback as a singleton so these paths can never leave two red markers.
    removeRotationCenterFeedback(host);
    // Create a temporary visual indicator at the rotation center
    const geometry = new THREE.SphereGeometry(0.01, 8, 6);
    const material = new THREE.MeshBasicMaterial({
        color: 0xff0000,
        transparent: true,
        opacity: 0.8,
    });
    const sphere = new THREE.Mesh(geometry, material);
    sphere.name = 'rotation-center-feedback';
    sphere.position.copy(point);
    host.scene.add(sphere);
    // Remove the indicator after 2 seconds
    const feedback = {
        geometry,
        material,
        sphere,
        timeout: null,
    };
    feedback.timeout = setTimeout(() => {
        removeRotationCenterFeedback(host, feedback);
        host.requestRender();
    }, 2000);
    feedbackByHost.set(host, feedback);
}
export function updateRotationOriginButtonState(host) {
    const btn = document.getElementById('set-rotation-origin');
    if (!btn) {
        return;
    }
    const t = host.controls?.target;
    const atOrigin = !!t && Math.abs(t.x) < 1e-9 && Math.abs(t.y) < 1e-9 && Math.abs(t.z) < 1e-9;
    if (atOrigin) {
        btn.classList.add('active');
    }
    else {
        btn.classList.remove('active');
    }
}
